import { render } from "./ReportWeekView.vue?vue&type=template&id=b6ea5f60&ts=true"
import script from "./ReportWeekView.vue?vue&type=script&lang=ts"
export * from "./ReportWeekView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__